import { CHAT_TRACE_CONFIG, useChatTraceState } from '@frontend/react-domain';
import {
  IconBalance,
  IconFlow,
  IconHarmony,
  IconLogo,
  IconPerception,
  Text,
  XStack,
  YStack,
} from '@frontend/web-react';

const keyframes = `
  @keyframes taskChatTraceShimmer {
    0% { background-position: 200% 0; }
    100% { background-position: 0% 0; }
  }
`;

const shimmerStyle: React.CSSProperties = {
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animation: 'taskChatTraceShimmer 3s infinite linear',
  background: `linear-gradient(
    90deg,
    #7d7d7d 0%,
    #7d7d7d 17%,
    #292929 21%,
    #1a1a1a 25%,
    #292929 29%,
    #7d7d7d 33%,
    #7d7d7d 67%,
    #292929 71%,
    #1a1a1a 75%,
    #292929 79%,
    #7d7d7d 83%,
    #7d7d7d 100%
  )`,
  backgroundClip: 'text',
  backgroundSize: '200% 100%',
  color: 'transparent',
};

const iconComponents = {
  balance: IconBalance,
  flow: IconFlow,
  harmony: IconHarmony,
  perception: IconPerception,
} as const;

type TaskChatTraceProps = {
  thinkingTrace?: { message: string; tool_name: string };
};

export const TaskChatTrace = ({ thinkingTrace }: TaskChatTraceProps) => {
  const { currentIconKey, logoState, message, showLongWaitMessage } = useChatTraceState({
    thinkingTrace,
  });

  const IconComponent =
    iconComponents[currentIconKey as keyof typeof iconComponents] ?? iconComponents[CHAT_TRACE_CONFIG.iconKeys[0]];

  return (
    <>
      <style>{keyframes}</style>
      <XStack alignItems="center" gap="sm">
        {logoState !== 'hidden' ? <IconLogo animated animationState={logoState} /> : <IconComponent animated />}
        <YStack>
          <span className="text-p-md" style={shimmerStyle}>
            {message}
          </span>
          {showLongWaitMessage ? (
            <Text color="tertiary" type="caption">
              This might take a moment — feel free to navigate away, we&apos;ll notify you when it&apos;s done.
            </Text>
          ) : null}
        </YStack>
      </XStack>
    </>
  );
};
